export default __webpack_public_path__ + "images/assets/19a0447aed358513be2e7c4a87352b97.svg";